module.exports = __webpack_public_path__ + "img/拉手锁2.46b62d44.jpg";